<div class="hpanel sticky-topper">
  <ul class="custom-panel pad-0 border-radius-top-left-right-6">
    <li class="active" (click)="menuclick('home')" [class.active]="isChildActive('/networkPage/home')">
      <a class="navIteam" >
        <div class="nav-margin">Home </div>
      </a>
    </li>
    <li class="active" (click)="menuclick('aboutus')" [class.active]="isChildActive('/networkPage/aboutus')">
      <a class="navIteam" >
        <div class="nav-margin">About</div>
      </a>
    </li>

    <!-- Label navigates, arrow only toggles (same fix as the business and workspace
         side menus): a shared toggle-and-navigate handler lost the expand whenever
         the navigation rebuilt this component, so Invites Sent was unreachable. -->
    <div class="cursor-ponit ui" id="rty" style="padding: 8px 15px;" (click)="menuclick('members')"
    [class.active]="isChildActive('/networkPage/members?')">
      <div class="cursor-ponit" routerLinkActive="active" > Members
        <span class="join-req" *ngIf="membermenuflag && networkOwnerFlag && pendingCount>0">{{pendingCount}}</span>
      </div>
      <div class="chevron-position" *ngIf="networkOwnerFlag && !isDefaultNetwork" (click)="toggleSubMenu($event)">
        <svg class="menu-chevron" [class.collapsed]="membermenuflag" width="20px" height="20px" viewBox="0 0 24 24" fill="none">
          <rect width="24" height="24" fill="none"/>
          <path d="M7 14.5L12 9.5L17 14.5" stroke="#000000" stroke-linecap="round" stroke-linejoin="round"/>
        </svg>
      </div>
    </div>
    <!-- Plain CSS transition instead of ngx-bootstrap's [collapse]/[isAnimated]: that
         directive (5.6.2) only applies a [collapse] change when `!this._player ||
         this._isAnimationDone`, so a click made during its 400ms open animation was
         silently dropped until the animation's onDone fired — that's why closing the
         Members dropdown right after opening it looked like it "didn't work" the first
         time. Driving the class straight off our own `membermenuflag` has no such
         window: every click applies immediately, and the max-height transition below
         still animates it smoothly. -->
    <div class="custom-panel menu-submenu" [class.menu-submenu-open]="!membermenuflag" *ngIf="networkOwnerFlag">
      <ul id="grouplist" class="list-group cursor-ponit ">
        <ng-container>
          <li class="list-group-item line_bw active cursor-ponit common-font-12 b-r-0 no-br"
          *ngIf="networkOwnerFlag && !isDefaultNetwork"
          [class.active]="isChildActive('/networkPage/inviteSent')" (click)="menuclick('inviteSent')" routerLinkActive="active">
            Invites Sent
            <span class="join-req" *ngIf="pendingCount>0 && networkOwnerFlag && !membermenuflag">{{pendingCount}}</span>
          </li>
        </ng-container>
      </ul>
    </div>
  </ul>
</div>
